<template>
  <section id="nav" class="flex-row flex-main-between flex-cross-center" style="padding:0 1.38rem">
    <hgroup style="width:.50rem;min-height:.50rem;border-radius:50%;background:white;" class="flex-center">
      <img src="@/assets/logo.png" style="width:.40rem;min-height:.40rem;">
    </hgroup>
    <h2 style="margin-left: .1rem;">AdaPundi</h2>
    <div id="tkb">TKB90 = 96.36%</div>
    <h4 @click="btnNav(item)" style="cursor: pointer" v-for="(item,index) in tab" :key="item.id">
      {{item.text}}
    </h4>
  </section>
</template>
<script>


export default {
  name: "nav",
  data() {
    return {
      tab:[
      {text:'Home',id:"index"},
      {text:'Pinjaman',id:"loan"},
      {text:'Investasi Pinjaman',id:"invest"},
      {text:'Tentang Kami',id:"contact"},
      {text:'CS SOP',id:"cs-sop"},
      {text:'FAQ',id:"help"}]
    };
  },
  methods: {
      btnNav(item){
        let parent=this.$parent;
        if (item.id === 'cs-sop') {
          window.open('./SOP.pdf')
        }else {
          this.$parent.openView(item.id);
        }
        return item;
      }
  },
  components: {
  }
};

</script>
<style scoped lang="scss">
  #nav{
    width:100%;min-height:.72rem;//0.72rem;
    background: #20cead;
  }
  #tkb{
    font-size: 0.1rem;
    color: white;
    width: 1rem;
    margin-right: 2rem;
  }
</style>
